import { colors } from 'theme/colors';
import { variants, scales } from './types';

export const styleVariants = {
  [variants.PRIMARY]: {
    background: colors.primary,
    color: 'text',
  },
  [variants.TEXT]: {
    background: 'transparent',
    color: 'text',

    '&:disabled': {
      background: 'transparent !important',
      borderColor: 'transparent !important',
    },
  },
  [variants.SECONDARY]: {
    backgroundColor: 'backgroundAlt3',
    boxShadow: 'none',
    color: 'text',
    ':disabled': {
      backgroundColor: 'transparent',
    },
  },
  [variants.ROUND]: {
    width: '100%',
    border: 0,
    borderRadius: '40px',
    color: 'text',
    background: 'transparent',
  },
  [variants.HIGHLIGHT]: {
    background: colors.buttonBackgroundAlt,
    color: 'text',
  },
  [variants.GRADIENT]: {
    background: colors.gradient.tertiary,
    color: 'text',
  },
  [variants.LIGHT]: {
    background: colors.text,
    color: 'primary',
  },
};

export const styleScales = {
  [scales.SM]: {
    height: '30px',
  },
  [scales.MD]: {
    height: '46px',
  },
  [scales.LG]: {
    height: '55px',
  },
};
